module.exports = __webpack_public_path__ + "img/PL00109.0403630b.png";